import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import '../Pages/Residential.css';
import ResiBan from "../Components/ResiBan";
import SEO from "../Components/SEO";
import { FaCouch, FaSwimmingPool, FaTree, FaShieldAlt, FaMapMarkerAlt, FaRulerCombined, FaInfoCircle } from "react-icons/fa";
import AOS from "aos";
import 'aos/dist/aos.css';

const residentialProjects = [
  {
    name: "VARK Royal Villa",
    location: "Bypass Road, Madurai",
    type: "Luxury Residential Villa",
    area: "3,200 sq.ft.",
    status: "Completed",
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=800&q=80"
  },
  {
    name: "VARK Golden Heights",
    location: "Iyer Bungalow, Madurai",
    type: "Individual Luxury House",
    area: "2,800 sq.ft.",
    status: "Completed",
    image: "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&w=800&q=80"
  },
  {
    name: "VARK Pride Enclave",
    location: "K.K. Nagar, Madurai",
    type: "Premium Villa Row",
    area: "4,500 sq.ft.",
    status: "Ongoing",
    image: "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?auto=format&fit=crop&w=800&q=80"
  },
  {
    name: "VARK Elite Residence",
    location: "Anna Nagar, Madurai",
    type: "Luxury Individual Villa",
    area: "3,500 sq.ft.",
    status: "Completed",
    image: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=800&q=80"
  },
  {
    name: "VARK Oasis Homes",
    location: "Othakadai, Madurai",
    type: "Eco-Friendly Villa",
    area: "2,400 sq.ft.",
    status: "Ongoing",
    image: "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?auto=format&fit=crop&w=800&q=80"
  },
  {
    name: "VARK Horizon Duplex",
    location: "Mattuthavani, Madurai",
    type: "Modern Duplex House",
    area: "3,000 sq.ft.",
    status: "Completed",
    image: "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?auto=format&fit=crop&w=800&q=80"
  }
];

export default function Residential() {
  const [filter, setFilter] = useState("All");

  useEffect(() => {
    window.scrollTo(0, 0);
    AOS.init({ duration: 1000, once: true });
  }, []);

  const features = [
    { icon: <FaCouch />, title: "Smart Interiors", desc: "Modern living spaces designed for comfort and elegance." },
    { icon: <FaSwimmingPool />, title: "Premium Amenities", desc: "World-class facilities for a luxurious lifestyle." },
    { icon: <FaTree />, title: "Eco-friendly Design", desc: "Sustainable building practices and green spaces." },
    { icon: <FaShieldAlt />, title: "Structural Safety", desc: "Built with the highest safety standards and quality materials." },
  ];

  const filteredProjects = residentialProjects.filter(project => {
    if (filter === "All") return true;
    return project.status === filter;
  });

  return (
    <div className="residential-page">
      <SEO 
        title="Residential Projects" 
        description="Explore luxury villas and individual houses constructed by VARK Builders Private Limited in Madurai and across Tamil Nadu."
      />
      <ResiBan />
      
      <section className="resi-intro">
        <div className="container">
          <div className="section-header" data-aos="fade-up">
            <span className="subtitle">Luxury Living</span>
            <h2>Luxury Living <span>Redefined</span></h2>
            <p>We don't just build houses; we build homes where memories are created.</p>
          </div>
          
          <div className="resi-features-grid">
            {features.map((feat, index) => (
              <div className="resi-feature-card" key={index} data-aos="fade-up" data-aos-delay={index * 100}>
                <div className="icon">{feat.icon}</div>
                <h3>{feat.title}</h3>
                <p>{feat.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Projects Grid Section with Filter */}
      <section className="resi-projects-section">
        <div className="container">
          <div className="section-header" data-aos="fade-up">
            <span className="subtitle">Our Portfolio</span>
            <h2>Residential <span>Showcase</span></h2>
            <p>Explore our wide array of premium residential villas and luxury homes.</p>
          </div>

          {/* Filtering buttons */}
          <div className="filter-buttons" data-aos="fade-up">
            {["All", "Completed", "Ongoing"].map((cat) => (
              <button
                key={cat}
                className={`filter-btn ${filter === cat ? "active" : ""}`}
                onClick={() => setFilter(cat)}
              >
                {cat}
              </button>
            ))}
          </div>

          {/* Projects grid */}
          <div className="resi-projects-grid">
            {filteredProjects.map((project, index) => (
              <div 
                className="resi-project-card" 
                key={index} 
                data-aos="fade-up" 
                data-aos-delay={(index % 3) * 100}
              >
                <div className="project-img-wrapper">
                  <img src={project.image} alt={project.name} loading="lazy" />
                  <span className={`status-badge ${project.status.toLowerCase()}`}>
                    {project.status}
                  </span>
                </div>
                <div className="project-details-box">
                  <h3>{project.name}</h3>
                  <div className="details-row">
                    <span className="detail-item"><FaInfoCircle /> {project.type}</span>
                  </div>
                  <div className="details-row">
                    <span className="detail-item"><FaMapMarkerAlt /> {project.location}</span>
                    <span className="detail-item"><FaRulerCombined /> {project.area}</span>
                  </div>
                  <div className="project-card-actions">
                    <Link to="/contact" className="action-btn-secondary">View Details</Link>
                    <Link to="/contact" className="action-btn-primary">Request Quote</Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="resi-process">
        <div className="container">
          <div className="process-split">
            <div className="process-img" data-aos="fade-right">
              <img 
                src="https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=800&q=80" 
                alt="Residential Process" 
                loading="lazy"
              />
            </div>
            <div className="process-text" data-aos="fade-left">
              <h2>Our Seamless <span>Process</span></h2>
              <div className="step">
                <span>01</span>
                <div>
                  <h4>Consultation & Planning</h4>
                  <p>Initial discussion to understand your vision, requirements, and budget parameters.</p>
                </div>
              </div>
              <div className="step">
                <span>02</span>
                <div>
                  <h4>Design & Approval</h4>
                  <p>Drafting beautiful architectural elevations and securing necessary municipality building clearances.</p>
                </div>
              </div>
              <div className="step">
                <span>03</span>
                <div>
                  <h4>Quality Construction</h4>
                  <p>Developing robust foundation and framing setups with premium raw materials and close site checks.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
